interface ChatModalProps {
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ChatModal = ({ show, onClose, children }: ChatModalProps) => {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/30"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="
          fixed inset-0 bg-white
          md:top-0 md:right-0 md:left-auto
          md:h-screen md:w-[650px]
          md:rounded-l-2xl
          md:shadow-2xl
        "
      >
        {children}
      </div>
    </div>
  );
};

export default ChatModal;